// extracted by mini-css-extract-plugin
export default {"MasterCardCta":"MasterCardCta_sTWg2","MasterCardCta_button":"MasterCardCta_button_dH6hw"};